import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
import Layout from './components/common/Layout';
import ProjectsPage from './pages/ProjectsPage';
import ProjectLandingPage from './pages/ProjectLandingPage';
import ProjectDetailPage from './pages/ProjectDetailPage';
import SchemaMapperPage from './pages/SchemaMapperPage';
import SchemaMappingPreferencesPage from './pages/SchemaMappingPreferencesPage';
import GlobalConfigPage from './pages/GlobalConfigPage';
import ReportMatchingPage from './pages/ReportMatchingPage';
import ReportMatchingHistoryPage from './pages/ReportMatchingHistoryPage';
import ReportMatchingPreferencesPage from './pages/ReportMatchingPreferencesPage';
import ReportMatchingTelemetryPage from './pages/ReportMatchingTelemetryPage';
import ReportLookupPage from './pages/ReportLookupPage';
import DescriptionReviewPage from './pages/DescriptionReviewPage';
import ThemeReviewPage from './pages/ThemeReviewPage';

/**
 * Main Application Component
 * 
 * Routes:
 * - /schema-analyzer/projects - Project list and creation
 * - /schema-analyzer/projects/:projectId - Smart project landing
 * - /schema-analyzer/projects/:projectId/upload - Project detail with file upload
 * - /schema-analyzer/projects/:projectId/mapper - Schema mapping workflow
 * - /report-matching - Report matching workflow
 * - /keyword-config - Global configuration
 */
function App() {
    return (
        <Router>
            <Box sx={{ minHeight: '100vh' }}>
                <Routes>
                    <Route path="/" element={<Layout />}>
                        <Route index element={<Navigate to="/schema-analyzer/projects" replace />} />
                        <Route path="schema-analyzer">
                            <Route index element={<Navigate to="/schema-analyzer/projects" replace />} />
                            <Route path="projects" element={<ProjectsPage />} />
                            <Route path="projects/:projectId" element={<ProjectLandingPage />} />
                            <Route path="projects/:projectId/upload" element={<ProjectDetailPage />} />
                            <Route path="projects/:projectId/mapper" element={<SchemaMapperPage />} />
                            <Route path="preferences" element={<SchemaMappingPreferencesPage />} />
                            <Route path="projects/:projectId/review/:sourceSystem/:fileId" element={<DescriptionReviewPage />} />
                            <Route path="projects/:projectId/theme-review/:sourceSystem/:fileId" element={<ThemeReviewPage />} />
                        </Route>
                        <Route path="report-matching">
                            <Route index element={<Navigate to="/report-matching/workspaces" replace />} />
                            <Route path="workspaces" element={<ReportMatchingPage />} />
                            <Route path="workspaces/:workspaceId" element={<ReportMatchingPage />} />
                            <Route path="workspaces/:workspaceId/telemetry" element={<ReportMatchingTelemetryPage />} />
                            <Route path="workspaces/:workspaceId/history" element={<ReportMatchingHistoryPage />} />
                            <Route path="report-lookup" element={<ReportLookupPage />} />
                            <Route path="preferences" element={<ReportMatchingPreferencesPage />} />
                        </Route>
                        <Route path="keyword-config" element={<GlobalConfigPage />} />
                    </Route>
                </Routes>
            </Box>
        </Router>
    );
}

export default App;

